<nav aria-label="Page navigation">
  <ul class="pagination">
    <ng-container
      *ngFor="let item of pages; index as i; first as isFirst; last as isLast">
      <li
        [class.active]="isCurrent(item)"
        [class.disabled]="isInactive(item)"
        class="page-item">
        <a
          (click)="pageChange(item)"
          [attr.aria-label]="getAriaLabel(item.label ?? '', $any(item.type))"
          [queryParams]="getQueryParams(item)"
          [routerLink]="pageRoute"
          [tabIndex]="isInactive(item) ? -1 : 0"
          class="page-link">
          <ng-container *ngIf="isFirst">
            <rrs-icon [icon]="iconTypeList.CHEVRON_LEFT" [size]="16"></rrs-icon>
          </ng-container>
          <ng-container *ngIf="!isFirst && !isLast">
            {{ item.label }}
          </ng-container>
          <ng-container *ngIf="isLast">
            <rrs-icon [icon]="iconTypeList.CHEVRON_RIGHT" [size]="16">
            </rrs-icon>
          </ng-container>
        </a>
      </li>
    </ng-container>
  </ul>
</nav>
